import * as styles from '@theme/styles';

export const titleContainer = {
  '&.MuiPaper-elevation0': {
    '&.MuiCard-root': {
      padding: '16px 0px 8px 16px',
      borderRadius: '0px',
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)', // TODO theme borders
    },
    ...styles.cardActionHeader,
  },
} as const;

export const drawerHeader = {
  width: '100%',
  backgroundColor: 'drawerNavigation.main',
  borderBottom: '1px solid rgba(0, 0, 0, 0.15)', // TODO theme borders
};

export const listNoteContainer = {
  backgroundColor: 'drawerNavigation.alt',
  height: '24px',
  marginBottom: '8px',
} as const;

export const parentContainer = {
  width: '100%',
  height: { xs: '100vh', sm: '100%' },
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  position: 'relative',
} as const;

export const scrollContainer = {
  backgroundColor: 'drawerNavigation.light',
  overflow: 'auto',
  margin: '0px',
  flexGrow: '1',

  overflowY: 'scroll',

  '&::-webkit-scrollbar': {
    width: '8px',
    display: 'block', // Ensure scrollbar is always visible
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'scrollBar.thumbBackground',
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'scrollBar.trackBackground',
  },
  scrollbarWidth: 'thin', // For Firefox
  scrollbarColor: 'scrollBar.scrollBarColor',
};

export const boxPadding = {
  padding: '16px 16px 0px',
} as const;

export const overflowXHiddenYAuto = {
  overflowX: 'hidden',
  overflowY: 'auto',
} as const;

export const saveButtonBox = {
  marginTop: 'auto',
  padding: '16px',
  borderTop: '1px solid rgba(0, 0, 0, 0.1)', // TODO theme borders
  backgroundColor: 'white',
  display: 'flex',
} as const;
